/*
 * @Description:
 * @Author: rqcheng
 * @Date: 2020-11-25 10:41:29
 * @LastEditors: rqcheng
 * @LastEditTime: 2025-06-20 15:58:14
 */
import axios from "axios";
import { baseURL, invalidCode, REPEAT_CODE } from "@/config";
import router from "@/router";
import { getAccessToken, removeAccessToken } from "../plugins/auth";
import { isString } from "../utils/validate";
import { Message } from "element-ui";

/**
 * @description: 异常code处理
 * @param {number} code
 * @param {string} msg
 */
const handleCode = (code, msg) => {
  // 处理错误码
  switch (code) {
    case invalidCode:
      removeAccessToken();
      Message.warning("登录失效请登录");
      router.push({ path: "/login" });
      break;
    // 默认提示函数
    // Vue.prototype.$baseMessage(msg || `后端接口${code}异常`, "error");
    // store.dispatch("user/resetAccessToken").catch(() => {});
    // if (loginInterception) location.reload();
    //   break;
    // case forbiddenCode:
    //   router.push({ path: '/401' }).catch(() => {});
    //   break;
    default:
      // 默认提示函数
      const _msg = msg || `后端接口${code}异常`;
      Message.error(isString(_msg) ? _msg : JSON.stringify(_msg));
      break;
  }
};

const instance = axios.create({
  baseURL: baseURL
});

instance.interceptors.request.use(
  res => {
    res.headers["current-token"] = "Bearer " + getAccessToken();
    return res;
  },
  err => {
    return Promise.reject(err);
  }
);

instance.interceptors.response.use(
  res => {
    return res;
  },
  err => {
    const { response } = err;
    if (response && response.data) {
      const { status, data } = response;
      handleCode(
        status,
        data && (data.msg || data.message || JSON.stringify(data))
      );
      return Promise.reject(err);
    } else {
      let { message } = err;
      if (message == REPEAT_CODE) {
        return Promise.reject({ message: "重复请求", error_code: REPEAT_CODE });
      } else if (message) {
        if (message === "Network Error") {
          message = "后端接口异常";
        }
        if (message.includes("timeout")) {
          message = "后端接口请求超时";
        }
        if (message.includes("Request failed with status code")) {
          const code = message.substr(message.length - 3);
          message = "后端接口" + code + "异常";
        }
      }
      Message.error(message || `后端接口未知异常`);
      // 全局消息提示
      return Promise.reject(err);
    }
  }
);
export default instance;



// WEBPACK FOOTER //
// ./src/api/httpService.js